module.exports = __webpack_public_path__ + "static/media/icon-unidades.2f116e17.svg";